module.exports = __webpack_public_path__ + "img/NFLogo.5dc713b9.png";